import React from 'react';
import { Box } from '@mui/material';
import { Alert, AlertTitle } from '@mui/material';

const SystemNotAvailable = () => (
  <Box mt={2}>
    <Alert severity="warning">
      <AlertTitle>
        System not available.
      </AlertTitle>
      
      The system is not available. Please contact your administrator.
    </Alert>
  </Box>
);

export default SystemNotAvailable;
